import { Color } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import type { BasketMarketOfferEntity } from '@genial/services';

import { CoeVariationStyle, CoeVariationStyleValueProp } from './types';

export const productItemAddedType = {
  fixedIncome: {
    backgroundColor: Color['product.rf'],
    title: 'RENDA FIXA',
  },
  funds: {
    backgroundColor: Color['product.fundos'],
    title: 'FUNDOS DE INVESTIMENTOS',
  },
  coes: {
    backgroundColor: Color['product.estruturados'],
    title: 'OPERAÇÕES ESTRUTURADAS',
  },
  equity: {
    backgroundColor: Color['product.rendavariavel'],
    title: 'RENDA VARIÁVEL',
  },
  directTreasury: {
    backgroundColor: Color['product.tesouro'],
    title: 'TESOURO DIRETO',
  },
} as const;

export const equityMaxLotSize = 1000000;
export const equityMinLotSize = 1;
export const equityMaxPriceItem = 1000000;
export const equityMinPriceItem = 0.01;
export const coeMaximumPriceItem = 1000000;
export const treasuryMaximumStepperValueItem = 0.01;
export const treasuryMaximumQuantityItem = 1000000;

export const getCoeVariationStyle = (
  value: CoeVariationStyleValueProp
): Partial<CoeVariationStyle> => {
  const style = {
    1: {
      color: 'feedback.success.default',
      name: 'ArrowUp' as IconographyTypes.Option,
    },
    2: {
      color: 'feedback.error.default',
      name: 'ArrowDown' as IconographyTypes.Option,
    },
    3: {
      color: 'brand.primary.principal',
      name: 'ArrowRight' as IconographyTypes.Option,
    },
    error: {},
  };

  return style[value || 'error'];
};

export const calculateAllocatedBalance = (customerOffers?: BasketMarketOfferEntity[]) => {
  const totalMarketAmount =
    customerOffers?.reduce((totalAcc, offer) => {
      const totalAmount =
        offer.basketOffers?.reduce((offerAcc, basketOffer) => {
          return offerAcc + basketOffer.amount;
        }, 0) || 0;

      return totalAcc + totalAmount;
    }, 0) || 0;

  return totalMarketAmount;
};

export const validatePercentage = (value: number): number => {
  if (value > 100) {
    return 100;
  }
  if (value < -100) {
    return -100;
  }
  return value;
};
